import { CAMPAIGN } from "@/config/campaign";

const LAUNCH_TS = new Date(CAMPAIGN.launchIso).getTime();
const DEADLINE_TS = new Date(CAMPAIGN.deadlineIso).getTime();

// Rein kosmetischer Preview-Override (?phase=prelaunch|active|closed).
// Die verbindliche Zeitlogik erzwingt der Server beim Absenden.
const getOverride = () => {
  try {
    const p = new URLSearchParams(window.location.search).get("phase");
    return ["prelaunch", "active", "closed"].includes(p) ? p : null;
  } catch {
    return null;
  }
};

// "prelaunch" | "active" | "closed" — Zeitlogik Europe/Zurich via ISO-Offsets in campaign.js
export const getPhase = (now = Date.now()) => {
  const override = getOverride();
  if (override) return override;
  if (now < LAUNCH_TS) return "prelaunch";
  if (now > DEADLINE_TS) return "closed";
  return "active";
};

export const getCountdownTarget = (phase) =>
  phase === "prelaunch" ? LAUNCH_TS : DEADLINE_TS;
